// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as HealthRouteImport } from './../routes/health'
import { Route as _authedRouteImport } from './../routes/__authed'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as AuthLogoutRouteImport } from './../routes/auth/logout'
import { Route as AuthLoginRouteImport } from './../routes/auth/login'
import { Route as _authedMRouteImport } from './../routes/__authed/m'
import { Route as _authedMWorkRouteImport } from './../routes/__authed/m/work'
import { Route as _authedMTechniciansRouteImport } from './../routes/__authed/m/technicians'
import { Route as _authedMSuppliersRouteImport } from './../routes/__authed/m/suppliers'
import { Route as _authedMStockRouteImport } from './../routes/__authed/m/stock'
import { Route as _authedMSettingsRouteImport } from './../routes/__authed/m/settings'
import { Route as _authedMReportsRouteImport } from './../routes/__authed/m/reports'
import { Route as _authedMRepairsRouteImport } from './../routes/__authed/m/repairs'
import { Route as _authedMPurchasesRouteImport } from './../routes/__authed/m/purchases'
import { Route as _authedMNotesRouteImport } from './../routes/__authed/m/notes'
import { Route as _authedMMaterialsRouteImport } from './../routes/__authed/m/materials'
import { Route as _authedMDashboardRouteImport } from './../routes/__authed/m/dashboard'
import { Route as _authedMCustomersRouteImport } from './../routes/__authed/m/customers'
import { Route as _authedMComplaintsRouteImport } from './../routes/__authed/m/complaints'
import { Route as _authedMCommissionsRouteImport } from './../routes/__authed/m/commissions'
import { Route as _authedMAdminRouteImport } from './../routes/__authed/m/admin'
import { Route as _authedMStockIndexRouteImport } from './../routes/__authed/m/stock/index'
import { Route as _authedMStockMaterialGroupsRouteImport } from './../routes/__authed/m/stock/material-groups'
import { Route as _authedMStockCustomerMaterialsRouteImport } from './../routes/__authed/m/stock/customer-materials'
import { Route as _authedMReportsProfitsRouteImport } from './../routes/__authed/m/reports/profits'
import { Route as _authedMReportsCommissionsRouteImport } from './../routes/__authed/m/reports/commissions'
import { Route as _authedMRepairsIndexRouteImport } from './../routes/__authed/m/repairs/index'
import { Route as _authedMRepairsWarrantyRouteImport } from './../routes/__authed/m/repairs/warranty'
import { Route as _authedMRepairsScreeningRouteImport } from './../routes/__authed/m/repairs/screening'
import { Route as _authedMRepairsReportsRouteImport } from './../routes/__authed/m/repairs/reports'
import { Route as _authedMRepairsProblematicRouteImport } from './../routes/__authed/m/repairs/problematic'
import { Route as _authedMRepairsNewRouteImport } from './../routes/__authed/m/repairs/new'
import { Route as _authedMRepairsInTransitRouteImport } from './../routes/__authed/m/repairs/in-transit'
import { Route as _authedMRepairsDeliveriesRouteImport } from './../routes/__authed/m/repairs/deliveries'
import { Route as _authedMRepairsIdRouteImport } from './../routes/__authed/m/repairs/$id'
import { Route as _authedMPurchasesIndexRouteImport } from './../routes/__authed/m/purchases/index'
import { Route as _authedMPurchasesWaitingRouteImport } from './../routes/__authed/m/purchases/waiting'
import { Route as _authedMMaterialsIndexRouteImport } from './../routes/__authed/m/materials/index'
import { Route as _authedMMaterialsResellerRouteImport } from './../routes/__authed/m/materials/reseller'
import { Route as _authedMMaterialsRequestsRouteImport } from './../routes/__authed/m/materials/requests'
import { Route as _authedMMaterialsDamagedRouteImport } from './../routes/__authed/m/materials/damaged'
import { Route as _authedMDashboardIndexRouteImport } from './../routes/__authed/m/dashboard/index'
import { Route as _authedMDashboardOwnerRouteImport } from './../routes/__authed/m/dashboard/owner'
import { Route as _authedMCustomersIndexRouteImport } from './../routes/__authed/m/customers/index'
import { Route as _authedMCustomersOngoingRouteImport } from './../routes/__authed/m/customers/ongoing'
import { Route as _authedMCustomersHistoryRouteImport } from './../routes/__authed/m/customers/history'
import { Route as _authedMCustomersGroupsRouteImport } from './../routes/__authed/m/customers/groups'
import { Route as _authedMCustomersContactsRouteImport } from './../routes/__authed/m/customers/contacts'
import { Route as _authedMComplaintsNewRouteImport } from './../routes/__authed/m/complaints/new'
import { Route as _authedMCommissionsIndexRouteImport } from './../routes/__authed/m/commissions/index'
import { Route as _authedMCommissionsDailyRouteImport } from './../routes/__authed/m/commissions/daily'
import { Route as _authedMCommissionsClosedRepairsRouteImport } from './../routes/__authed/m/commissions/closed-repairs'
import { Route as _authedMAdminUsersRouteImport } from './../routes/__authed/m/admin/users'
import { Route as _authedMAdminTypesRouteImport } from './../routes/__authed/m/admin/types'
import { Route as _authedMAdminEntitiesRouteImport } from './../routes/__authed/m/admin/entities'
import { Route as _authedMRepairsExternalNewRouteImport } from './../routes/__authed/m/repairs/external/new'
import { Route as _authedMRepairsClosedTodayRouteImport } from './../routes/__authed/m/repairs/closed/today'
import { Route as _authedMRepairsReportsClosedByTechnicianTodayRouteImport } from './../routes/__authed/m/repairs/reports/closed-by-technician-today'

const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const _authedRoute = _authedRouteImport.update({
            id: '/__authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/auth/logout',path: '/auth/logout',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const _authedMRoute = _authedMRouteImport.update({
            id: '/m',path: '/m',getParentRoute: () => _authedRoute
          })
const _authedMWorkRoute = _authedMWorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => _authedMRoute
          })
const _authedMTechniciansRoute = _authedMTechniciansRouteImport.update({
            id: '/technicians',path: '/technicians',getParentRoute: () => _authedMRoute
          })
const _authedMSuppliersRoute = _authedMSuppliersRouteImport.update({
            id: '/suppliers',path: '/suppliers',getParentRoute: () => _authedMRoute
          })
const _authedMStockRoute = _authedMStockRouteImport.update({
            id: '/stock',path: '/stock',getParentRoute: () => _authedMRoute
          })
const _authedMSettingsRoute = _authedMSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => _authedMRoute
          })
const _authedMReportsRoute = _authedMReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => _authedMRoute
          })
const _authedMRepairsRoute = _authedMRepairsRouteImport.update({
            id: '/repairs',path: '/repairs',getParentRoute: () => _authedMRoute
          })
const _authedMPurchasesRoute = _authedMPurchasesRouteImport.update({
            id: '/purchases',path: '/purchases',getParentRoute: () => _authedMRoute
          })
const _authedMNotesRoute = _authedMNotesRouteImport.update({
            id: '/notes',path: '/notes',getParentRoute: () => _authedMRoute
          })
const _authedMMaterialsRoute = _authedMMaterialsRouteImport.update({
            id: '/materials',path: '/materials',getParentRoute: () => _authedMRoute
          })
const _authedMDashboardRoute = _authedMDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => _authedMRoute
          })
const _authedMCustomersRoute = _authedMCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => _authedMRoute
          })
const _authedMComplaintsRoute = _authedMComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => _authedMRoute
          })
const _authedMCommissionsRoute = _authedMCommissionsRouteImport.update({
            id: '/commissions',path: '/commissions',getParentRoute: () => _authedMRoute
          })
const _authedMAdminRoute = _authedMAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => _authedMRoute
          })
const _authedMStockIndexRoute = _authedMStockIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMStockRoute
          })
const _authedMStockMaterialGroupsRoute = _authedMStockMaterialGroupsRouteImport.update({
            id: '/material-groups',path: '/material-groups',getParentRoute: () => _authedMStockRoute
          })
const _authedMStockCustomerMaterialsRoute = _authedMStockCustomerMaterialsRouteImport.update({
            id: '/customer-materials',path: '/customer-materials',getParentRoute: () => _authedMStockRoute
          })
const _authedMReportsProfitsRoute = _authedMReportsProfitsRouteImport.update({
            id: '/profits',path: '/profits',getParentRoute: () => _authedMReportsRoute
          })
const _authedMReportsCommissionsRoute = _authedMReportsCommissionsRouteImport.update({
            id: '/commissions',path: '/commissions',getParentRoute: () => _authedMReportsRoute
          })
const _authedMRepairsIndexRoute = _authedMRepairsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsWarrantyRoute = _authedMRepairsWarrantyRouteImport.update({
            id: '/warranty',path: '/warranty',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsScreeningRoute = _authedMRepairsScreeningRouteImport.update({
            id: '/screening',path: '/screening',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsReportsRoute = _authedMRepairsReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsProblematicRoute = _authedMRepairsProblematicRouteImport.update({
            id: '/problematic',path: '/problematic',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsNewRoute = _authedMRepairsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsInTransitRoute = _authedMRepairsInTransitRouteImport.update({
            id: '/in-transit',path: '/in-transit',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsDeliveriesRoute = _authedMRepairsDeliveriesRouteImport.update({
            id: '/deliveries',path: '/deliveries',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsIdRoute = _authedMRepairsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMPurchasesIndexRoute = _authedMPurchasesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMPurchasesRoute
          })
const _authedMPurchasesWaitingRoute = _authedMPurchasesWaitingRouteImport.update({
            id: '/waiting',path: '/waiting',getParentRoute: () => _authedMPurchasesRoute
          })
const _authedMMaterialsIndexRoute = _authedMMaterialsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMMaterialsRoute
          })
const _authedMMaterialsResellerRoute = _authedMMaterialsResellerRouteImport.update({
            id: '/reseller',path: '/reseller',getParentRoute: () => _authedMMaterialsRoute
          })
const _authedMMaterialsRequestsRoute = _authedMMaterialsRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => _authedMMaterialsRoute
          })
const _authedMMaterialsDamagedRoute = _authedMMaterialsDamagedRouteImport.update({
            id: '/damaged',path: '/damaged',getParentRoute: () => _authedMMaterialsRoute
          })
const _authedMDashboardIndexRoute = _authedMDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMDashboardRoute
          })
const _authedMDashboardOwnerRoute = _authedMDashboardOwnerRouteImport.update({
            id: '/owner',path: '/owner',getParentRoute: () => _authedMDashboardRoute
          })
const _authedMCustomersIndexRoute = _authedMCustomersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMCustomersRoute
          })
const _authedMCustomersOngoingRoute = _authedMCustomersOngoingRouteImport.update({
            id: '/ongoing',path: '/ongoing',getParentRoute: () => _authedMCustomersRoute
          })
const _authedMCustomersHistoryRoute = _authedMCustomersHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => _authedMCustomersRoute
          })
const _authedMCustomersGroupsRoute = _authedMCustomersGroupsRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => _authedMCustomersRoute
          })
const _authedMCustomersContactsRoute = _authedMCustomersContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => _authedMCustomersRoute
          })
const _authedMComplaintsNewRoute = _authedMComplaintsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => _authedMComplaintsRoute
          })
const _authedMCommissionsIndexRoute = _authedMCommissionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => _authedMCommissionsRoute
          })
const _authedMCommissionsDailyRoute = _authedMCommissionsDailyRouteImport.update({
            id: '/daily',path: '/daily',getParentRoute: () => _authedMCommissionsRoute
          })
const _authedMCommissionsClosedRepairsRoute = _authedMCommissionsClosedRepairsRouteImport.update({
            id: '/closed-repairs',path: '/closed-repairs',getParentRoute: () => _authedMCommissionsRoute
          })
const _authedMAdminUsersRoute = _authedMAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => _authedMAdminRoute
          })
const _authedMAdminTypesRoute = _authedMAdminTypesRouteImport.update({
            id: '/types',path: '/types',getParentRoute: () => _authedMAdminRoute
          })
const _authedMAdminEntitiesRoute = _authedMAdminEntitiesRouteImport.update({
            id: '/entities',path: '/entities',getParentRoute: () => _authedMAdminRoute
          })
const _authedMRepairsExternalNewRoute = _authedMRepairsExternalNewRouteImport.update({
            id: '/external/new',path: '/external/new',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsClosedTodayRoute = _authedMRepairsClosedTodayRouteImport.update({
            id: '/closed/today',path: '/closed/today',getParentRoute: () => _authedMRepairsRoute
          })
const _authedMRepairsReportsClosedByTechnicianTodayRoute = _authedMRepairsReportsClosedByTechnicianTodayRouteImport.update({
            id: '/closed-by-technician-today',path: '/closed-by-technician-today',getParentRoute: () => _authedMRepairsReportsRoute
          })





const _authedMAdminRouteChildren = {
  _authedMAdminEntitiesRoute: _authedMAdminEntitiesRoute,_authedMAdminTypesRoute: _authedMAdminTypesRoute,_authedMAdminUsersRoute: _authedMAdminUsersRoute
}

const _authedMAdminRouteWithChildren = _authedMAdminRoute._addFileChildren(_authedMAdminRouteChildren)




const _authedMCommissionsRouteChildren = {
  _authedMCommissionsClosedRepairsRoute: _authedMCommissionsClosedRepairsRoute,_authedMCommissionsDailyRoute: _authedMCommissionsDailyRoute,_authedMCommissionsIndexRoute: _authedMCommissionsIndexRoute
}

const _authedMCommissionsRouteWithChildren = _authedMCommissionsRoute._addFileChildren(_authedMCommissionsRouteChildren)




const _authedMComplaintsRouteChildren = {
  _authedMComplaintsNewRoute: _authedMComplaintsNewRoute
}

const _authedMComplaintsRouteWithChildren = _authedMComplaintsRoute._addFileChildren(_authedMComplaintsRouteChildren)




const _authedMCustomersRouteChildren = {
  _authedMCustomersContactsRoute: _authedMCustomersContactsRoute,_authedMCustomersGroupsRoute: _authedMCustomersGroupsRoute,_authedMCustomersHistoryRoute: _authedMCustomersHistoryRoute,_authedMCustomersOngoingRoute: _authedMCustomersOngoingRoute,_authedMCustomersIndexRoute: _authedMCustomersIndexRoute
}

const _authedMCustomersRouteWithChildren = _authedMCustomersRoute._addFileChildren(_authedMCustomersRouteChildren)




const _authedMDashboardRouteChildren = {
  _authedMDashboardOwnerRoute: _authedMDashboardOwnerRoute,_authedMDashboardIndexRoute: _authedMDashboardIndexRoute
}

const _authedMDashboardRouteWithChildren = _authedMDashboardRoute._addFileChildren(_authedMDashboardRouteChildren)




const _authedMMaterialsRouteChildren = {
  _authedMMaterialsDamagedRoute: _authedMMaterialsDamagedRoute,_authedMMaterialsRequestsRoute: _authedMMaterialsRequestsRoute,_authedMMaterialsResellerRoute: _authedMMaterialsResellerRoute,_authedMMaterialsIndexRoute: _authedMMaterialsIndexRoute
}

const _authedMMaterialsRouteWithChildren = _authedMMaterialsRoute._addFileChildren(_authedMMaterialsRouteChildren)




const _authedMPurchasesRouteChildren = {
  _authedMPurchasesWaitingRoute: _authedMPurchasesWaitingRoute,_authedMPurchasesIndexRoute: _authedMPurchasesIndexRoute
}

const _authedMPurchasesRouteWithChildren = _authedMPurchasesRoute._addFileChildren(_authedMPurchasesRouteChildren)




const _authedMRepairsReportsRouteChildren = {
  _authedMRepairsReportsClosedByTechnicianTodayRoute: _authedMRepairsReportsClosedByTechnicianTodayRoute
}

const _authedMRepairsReportsRouteWithChildren = _authedMRepairsReportsRoute._addFileChildren(_authedMRepairsReportsRouteChildren)



const _authedMRepairsRouteChildren = {
  _authedMRepairsIdRoute: _authedMRepairsIdRoute,_authedMRepairsDeliveriesRoute: _authedMRepairsDeliveriesRoute,_authedMRepairsInTransitRoute: _authedMRepairsInTransitRoute,_authedMRepairsNewRoute: _authedMRepairsNewRoute,_authedMRepairsProblematicRoute: _authedMRepairsProblematicRoute,_authedMRepairsReportsRoute: _authedMRepairsReportsRouteWithChildren,_authedMRepairsScreeningRoute: _authedMRepairsScreeningRoute,_authedMRepairsWarrantyRoute: _authedMRepairsWarrantyRoute,_authedMRepairsIndexRoute: _authedMRepairsIndexRoute,_authedMRepairsClosedTodayRoute: _authedMRepairsClosedTodayRoute,_authedMRepairsExternalNewRoute: _authedMRepairsExternalNewRoute
}

const _authedMRepairsRouteWithChildren = _authedMRepairsRoute._addFileChildren(_authedMRepairsRouteChildren)




const _authedMReportsRouteChildren = {
  _authedMReportsCommissionsRoute: _authedMReportsCommissionsRoute,_authedMReportsProfitsRoute: _authedMReportsProfitsRoute
}

const _authedMReportsRouteWithChildren = _authedMReportsRoute._addFileChildren(_authedMReportsRouteChildren)




const _authedMStockRouteChildren = {
  _authedMStockCustomerMaterialsRoute: _authedMStockCustomerMaterialsRoute,_authedMStockMaterialGroupsRoute: _authedMStockMaterialGroupsRoute,_authedMStockIndexRoute: _authedMStockIndexRoute
}

const _authedMStockRouteWithChildren = _authedMStockRoute._addFileChildren(_authedMStockRouteChildren)



const _authedMRouteChildren = {
  _authedMAdminRoute: _authedMAdminRouteWithChildren,_authedMCommissionsRoute: _authedMCommissionsRouteWithChildren,_authedMComplaintsRoute: _authedMComplaintsRouteWithChildren,_authedMCustomersRoute: _authedMCustomersRouteWithChildren,_authedMDashboardRoute: _authedMDashboardRouteWithChildren,_authedMMaterialsRoute: _authedMMaterialsRouteWithChildren,_authedMNotesRoute: _authedMNotesRoute,_authedMPurchasesRoute: _authedMPurchasesRouteWithChildren,_authedMRepairsRoute: _authedMRepairsRouteWithChildren,_authedMReportsRoute: _authedMReportsRouteWithChildren,_authedMSettingsRoute: _authedMSettingsRoute,_authedMStockRoute: _authedMStockRouteWithChildren,_authedMSuppliersRoute: _authedMSuppliersRoute,_authedMTechniciansRoute: _authedMTechniciansRoute,_authedMWorkRoute: _authedMWorkRoute
}

const _authedMRouteWithChildren = _authedMRoute._addFileChildren(_authedMRouteChildren)



const _authedRouteChildren = {
  _authedMRoute: _authedMRouteWithChildren
}

const _authedRouteWithChildren = _authedRoute._addFileChildren(_authedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,_authedRoute: _authedRouteWithChildren,HealthRoute: HealthRoute,AuthLoginRoute: AuthLoginRoute,AuthLogoutRoute: AuthLogoutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)